// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppAppIndexRouteImport } from './routes/_app/app/index'
import { Route as AppSSessionIdRouteImport } from './routes/_app/s.$sessionId'
import { Route as AppJoinCodeRouteImport } from './routes/_app/join.$code'
import { Route as AppAppDeviceRouteImport } from './routes/_app/app/device'
import { Route as AppAppAdminRouteImport } from './routes/_app/app/admin'
import { Route as AppAppTeamIndexRouteImport } from './routes/_app/app/team/index'
import { Route as AppAppPrivateCwdRouteImport } from './routes/_app/app/private.$cwd'
import { Route as AppAppLogsIdRouteImport } from './routes/_app/app/logs.$id'

const WaitlistRoute = WaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppAppIndexRoute = AppAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AppRoute
          })
const AppSSessionIdRoute = AppSSessionIdRouteImport.update({
            id: '/s/$sessionId',path: '/s/$sessionId',getParentRoute: () => AppRoute
          })
const AppJoinCodeRoute = AppJoinCodeRouteImport.update({
            id: '/join/$code',path: '/join/$code',getParentRoute: () => AppRoute
          })
const AppAppDeviceRoute = AppAppDeviceRouteImport.update({
            id: '/app/device',path: '/app/device',getParentRoute: () => AppRoute
          })
const AppAppAdminRoute = AppAppAdminRouteImport.update({
            id: '/app/admin',path: '/app/admin',getParentRoute: () => AppRoute
          })
const AppAppTeamIndexRoute = AppAppTeamIndexRouteImport.update({
            id: '/app/team/',path: '/app/team/',getParentRoute: () => AppRoute
          })
const AppAppPrivateCwdRoute = AppAppPrivateCwdRouteImport.update({
            id: '/app/private/$cwd',path: '/app/private/$cwd',getParentRoute: () => AppRoute
          })
const AppAppLogsIdRoute = AppAppLogsIdRouteImport.update({
            id: '/app/logs/$id',path: '/app/logs/$id',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppAppAdminRoute: AppAppAdminRoute,AppAppDeviceRoute: AppAppDeviceRoute,AppJoinCodeRoute: AppJoinCodeRoute,AppSSessionIdRoute: AppSSessionIdRoute,AppAppIndexRoute: AppAppIndexRoute,AppAppLogsIdRoute: AppAppLogsIdRoute,AppAppPrivateCwdRoute: AppAppPrivateCwdRoute,AppAppTeamIndexRoute: AppAppTeamIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,WaitlistRoute: WaitlistRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)